import { apiHelper } from '@/util'

export const facebookPixelService = {
  getFacebookPixels,
  getChannelPixel,
  channelPageview
}

//API urls
const FACEBOOK = {
  FACEBOOK: 'facebook',
  GET_PIXELS: 'get-pixel',
  CHANNEL: 'channel'
}

function getFacebookPixels() {
  return apiHelper().get(`${FACEBOOK.FACEBOOK}/${FACEBOOK.GET_PIXELS}`)
}

// The one pixel bound to a channel (ad link ?i=); data.fb_pixel_id is null when none.
function getChannelPixel(channelId) {
  return apiHelper().get(`${FACEBOOK.CHANNEL}/${encodeURIComponent(channelId)}/pixel`)
}

// Channel click tracking; body: { fingerprint, referrer }
function channelPageview(channelId, body) {
  return apiHelper().post(`${FACEBOOK.CHANNEL}/${encodeURIComponent(channelId)}/pageview`, body)
}
